export default __webpack_public_path__ + "static/media/Skills.9e10f2e6.svg";